import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class GoogleService {
  auth = firebase.auth();
  firestore = firebase.firestore();
  storage = firebase.storage();
  userData: any;
  confirmationResult: any;

  constructor() {
    if (!firebase.apps.length) {
      firebase.initializeApp(environment.firebase);
    }
  }

  createAccount(email: string, password: string): Promise<any> {
    return this.auth.createUserWithEmailAndPassword(email, password)
      .then(response => response.user?.uid);
  }

  login(email: string, password: string): Promise<any> {
    return this.auth.signInWithEmailAndPassword(email, password)
      .then(response => response.user?.uid)
      .catch(error => Promise.reject(`Login failed: ${error.message}`));
  }

  forgotPassword(email: string): Promise<void> {
    return this.auth.sendPasswordResetEmail(email);
  }

  async googleLogin(): Promise<any> {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/calendar');
    provider.addScope('https://www.googleapis.com/auth/gmail.readonly');
    provider.addScope('https://www.googleapis.com/auth/gmail.modify');
    provider.addScope('https://mail.google.com/');
    provider.addScope('profile');
    provider.addScope('https://www.googleapis.com/auth/gmail.send');
    const result:any = await this.auth.signInWithPopup(provider);
    console.log("result", result)
    const googleAccessToken = result;
    return googleAccessToken;
  }

  async checkAuth(): Promise<any> {
    return new Promise(resolve => {
      this.auth.onAuthStateChanged(user => {
        this.userData = user;
        resolve(user);
      });
    });
  }

  logout(): Promise<void> {
    return this.auth.signOut();
  }
}
